import { useEffect, useState, useCallback, useRef } from 'react';
import { useQuery } from 'react-query';
import * as helpers from "../utils/utils.js";
import axios from 'axios';

import { useClientId } from '../context/context.js';

const apiBaseUrl = process.env.REACT_APP_API_URL;


export function useAvailability() {
    const clientId = useClientId();

  const fetchAvailability = async ({ firstDay, lastDay, status }) => {
    const params = new URLSearchParams({
      startDate: firstDay,
      endDate: lastDay,
    });
    if (status) params.append('status', status);

    const response = await axios.get(
      `${apiBaseUrl}/clients/${clientId}/date-slots?${params}`
    );

    return response.data;
  };

  return {
    fetchAvailability,
  }
};
